import { gql } from '@apollo/client'
import { isFeatureEnabled } from '~/config'

const isExpressEconomyEnabled = isFeatureEnabled('expressEconomy')

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends Record<string, unknown>> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The `BigDecimal` scalar type represents signed fractional values with arbitrary precision. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  BigDecimal: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  DateTime: any
  /** a java.time.Instant supporting ISO format 'yyyy-MM-dd'T'HH:mm:ss.SSSZ' in UTC zone */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Instant: any
  /** The `Long` scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Long: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  MapType: any
}

export type Address = {
  addition?: Maybe<Scalars['String']>
  additionalAddressLine?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<Scalars['String']>
  city: Scalars['String']
  countryCode: Scalars['String']
  isBusiness: Scalars['Boolean']
  number?: Maybe<Scalars['String']>
  street: Scalars['String']
  zipCode?: Maybe<Scalars['String']>
}

export type AddressBookAddress = {
  addition?: Maybe<Scalars['String']>
  additionalAddressLine?: Maybe<Scalars['String']>
  additionalInfo?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  isBusiness: Scalars['Boolean']
  number?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  zipCode?: Maybe<Scalars['String']>
}

export type AddressBookAddressInput = {
  addition?: InputMaybe<Scalars['String']>
  additionalAddressLine?: InputMaybe<Scalars['String']>
  additionalInfo?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  countryCode?: InputMaybe<Scalars['String']>
  isBusiness: Scalars['Boolean']
  number?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

export type AddressBookContainer = {
  addresses: AddressBookEntry[]
  count: Scalars['Int']
}

export type AddressBookContainerAddressesArgs = {
  countries?: InputMaybe<Scalars['String'][]>
  max?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  skip?: InputMaybe<Scalars['Int']>
  sortBy?: InputMaybe<SortByInput>
  tags?: InputMaybe<Scalars['String'][]>
}

export type AddressBookContainerCountArgs = {
  query?: InputMaybe<Scalars['String']>
}

export type AddressBookEntry = {
  accountId?: Maybe<Scalars['String']>
  address: AddressBookAddress
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  name: Name
  phoneNumber?: Maybe<Scalars['String']>
  reference?: Maybe<Scalars['String']>
  tags: Scalars['String'][]
}

export type AddressBookEntryInput = {
  accountId?: InputMaybe<Scalars['String']>
  address: AddressBookAddressInput
  email?: InputMaybe<EmailInput>
  eoriNumber?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  name: NameInput
  phoneNumber?: InputMaybe<Scalars['String']>
  reference?: InputMaybe<Scalars['String']>
  tags: Scalars['String'][]
  vatNumber?: InputMaybe<Scalars['String']>
}

export type AddressBookMutation = {
  createAddress: AddressBookEntry
  deleteAddress: Scalars['ID']
  updateAddress: AddressBookEntry
}

export type AddressBookMutationCreateAddressArgs = {
  addressBookEntry: AddressBookEntryInput
}

export type AddressBookMutationDeleteAddressArgs = {
  addressBookId: Scalars['ID']
}

export type AddressBookMutationUpdateAddressArgs = {
  addressBookEntry: AddressBookEntryInput
  addressBookId: Scalars['ID']
}

export type AddressInput = {
  addition?: InputMaybe<Scalars['String']>
  additionalAddressLine?: InputMaybe<Scalars['String']>
  additionalInfo?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  countryCode: Scalars['String']
  isBusiness: Scalars['Boolean']
  number?: InputMaybe<Scalars['String']>
  street: Scalars['String']
  zipCode?: InputMaybe<Scalars['String']>
}

export type Attachment = {
  content: Scalars['String']
  mimeType?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export type AttachmentInput = {
  content: Scalars['String']
  mimeType?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CapabilitiesContainer = {
  capabilities: Capability[]
  destinationCountries: Country[]
  handOffDates?: Maybe<HandOffDates>
  isCustomsDestinationQuery: Scalars['Boolean']
  originCountries: Scalars['String'][]
  parcelTypes: ParcelType[]
  timeWindows?: Maybe<TimeWindows[]>
  transitTimes?: Maybe<TransitTimes>
}

export type CapabilitiesContainerCapabilitiesArgs = {
  capabilitiesInput: CapabilitiesInput
}

export type CapabilitiesContainerDestinationCountriesArgs = {
  destinationCountriesInput: DestinationCountriesInput
}

export type CapabilitiesContainerHandOffDatesArgs = {
  handOffDatesInput: HandOffDatesInput
}

export type CapabilitiesContainerIsCustomsDestinationQueryArgs = {
  customsDestinationInput: CustomsDestinationInput
}

export type CapabilitiesContainerOriginCountriesArgs = {
  originCountriesInput: OriginCountriesInput
}

export type CapabilitiesContainerParcelTypesArgs = {
  parcelTypesInput: ParcelTypesInput
}

export type CapabilitiesContainerTimeWindowsArgs = {
  timeWindowsInput: TimeWindowsInput
}

export type CapabilitiesContainerTransitTimesArgs = {
  transitTimesInput: TransitTimesInput
}

export type CapabilitiesInput = {
  accountNumber?: InputMaybe<Scalars['String']>
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromBusiness: Scalars['Boolean']
  fromCountry?: InputMaybe<Scalars['String']>
  fromPostalCode?: InputMaybe<Scalars['String']>
  options?: InputMaybe<Scalars['String'][]>
  parcelType?: InputMaybe<Scalars['String']>
  referenceTimeStamp?: InputMaybe<Scalars['String']>
  returnProduct?: InputMaybe<Scalars['Boolean']>
  toBusiness?: InputMaybe<Scalars['Boolean']>
  toCity?: InputMaybe<Scalars['String']>
  toCountry?: InputMaybe<Scalars['String']>
  toPostalCode?: InputMaybe<Scalars['String']>
}

export type Capability = {
  deliveryArea?: Maybe<DeliveryArea>
  fromCountryCode: Scalars['String']
  maxQuantity?: Maybe<Scalars['Int']>
  minQuantity?: Maybe<Scalars['Int']>
  options: ShipmentOption[]
  parcelTypes: ParcelType
  productKey: Scalars['String']
  rank: Scalars['Int']
  toCountryCode: Scalars['String']
}

export enum ClientAppId {
  C2C = 'C2C',
  Pwa = 'PWA',
}

export type CompositePrice = {
  withTax: Scalars['BigDecimal']
  withoutTax: Scalars['BigDecimal']
}

export type Country = {
  code: Scalars['String']
  hasPostal: Scalars['Boolean']
}

export type CustomsDeclaration = {
  attachmentIds?: Maybe<Scalars['String'][]>
  attachments?: Maybe<Attachment[]>
  certificateNumber?: Maybe<Scalars['String']>
  currency?: Maybe<Scalars['String']>
  customsGoods: CustomsGood[]
  defermentAccountDuties?: Maybe<Scalars['String']>
  defermentAccountVat?: Maybe<Scalars['String']>
  exportReason?: Maybe<Scalars['String']>
  exportType?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  importerOfRecord?: Maybe<Receiver>
  incoTerms?: Maybe<Scalars['String']>
  incoTermsCity?: Maybe<Scalars['String']>
  invoiceNumber?: Maybe<Scalars['String']>
  invoiceType?: Maybe<Scalars['String']>
  licenceNumber?: Maybe<Scalars['String']>
  remarks?: Maybe<Scalars['String']>
  senderHasInboundEoriNumber?: Maybe<Scalars['Boolean']>
  senderInboundVatNumber?: Maybe<Scalars['String']>
  shippingFee?: Maybe<ShippingFee>
  vatReverseCharge?: Maybe<Scalars['Boolean']>
}

export type CustomsDeclarationInput = {
  attachmentIds?: InputMaybe<Scalars['String'][]>
  attachments?: InputMaybe<AttachmentInput[]>
  certificateNumber?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  customsGoods: CustomsGoodInput[]
  defermentAccountDuties?: InputMaybe<Scalars['String']>
  defermentAccountVat?: InputMaybe<Scalars['String']>
  exportReason?: InputMaybe<Scalars['String']>
  exportType?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['String']>
  importerOfRecord?: InputMaybe<ReceiverInput>
  incoTerms?: InputMaybe<Scalars['String']>
  incoTermsCity?: InputMaybe<Scalars['String']>
  invoiceNumber?: InputMaybe<Scalars['String']>
  invoiceType?: InputMaybe<Scalars['String']>
  licenceNumber?: InputMaybe<Scalars['String']>
  remarks?: InputMaybe<Scalars['String']>
  senderHasInboundEoriNumber?: InputMaybe<Scalars['Boolean']>
  senderInboundVatNumber?: InputMaybe<Scalars['String']>
  shippingFee?: InputMaybe<ShippingFeeInput>
  vatReverseCharge?: InputMaybe<Scalars['Boolean']>
}

export type CustomsDestinationInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  fromCountryCode: Scalars['String']
  fromPostalCode?: InputMaybe<Scalars['String']>
  productKey?: InputMaybe<Scalars['String']>
  toCountryCode: Scalars['String']
  toPostalCode?: InputMaybe<Scalars['String']>
}

export type CustomsGood = {
  code?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  origin?: Maybe<Scalars['String']>
  quantity?: Maybe<Scalars['Int']>
  value?: Maybe<Scalars['BigDecimal']>
  weight?: Maybe<Scalars['BigDecimal']>
}

export type CustomsGoodInput = {
  code?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  origin?: InputMaybe<Scalars['String']>
  quantity?: InputMaybe<Scalars['Int']>
  value?: InputMaybe<Scalars['BigDecimal']>
  weight?: InputMaybe<Scalars['BigDecimal']>
}

export type DeliveryArea = {
  remote: Scalars['Boolean']
  type: Scalars['String']
}

export type DestinationCountriesInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromBusiness: Scalars['Boolean']
  fromCountry: Scalars['String']
}

export type Dimensions = {
  maxHeightCm: Scalars['BigDecimal']
  maxLengthCm: Scalars['BigDecimal']
  maxSumCm?: Maybe<Scalars['BigDecimal']>
  maxWidthCm: Scalars['BigDecimal']
}

export type DimensionsInput = {
  maxHeightCm: Scalars['BigDecimal']
  maxLengthCm: Scalars['BigDecimal']
  maxSumCm?: InputMaybe<Scalars['BigDecimal']>
  maxWidthCm: Scalars['BigDecimal']
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Email = {
  address: Scalars['String']
}

export type EmailInput = {
  address: Scalars['String']
}

export type Emails = {
  addresses: Scalars['String']
}

export type EmailsInput = {
  addresses: Scalars['String']
}

export type EnrichedShipment = {
  application?: Maybe<Scalars['String']>
  archived: Scalars['Boolean']
  id: Scalars['String']
  options: ShipmentOption[]
  orderId: Scalars['ID']
  orderReference?: Maybe<OrderReference>
  printlessCode?: Maybe<Scalars['String']>
  receiver: Receiver
  shipmentId: Scalars['String']
  shipmentTrackerCode?: Maybe<Scalars['String']>
  shipper: Shipper
  timeCreated: Scalars['DateTime']
  timeUpdated?: Maybe<Scalars['DateTime']>
  total: CompositePrice
  trackAndTrace?: Maybe<TrackAndTraceInfo>
  trackerCode?: Maybe<Scalars['String']>
}

export type HandOffDate = {
  date: Scalars['String']
  days: TransitTimeDays
  expectedDeliveryDate?: Maybe<Scalars['String']>
  pickupRangeBound?: Maybe<PickupRangeBound>
}

export type HandOffDates = {
  handOffDates: HandOffDate[]
}

export type HandOffDatesInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromCountry?: InputMaybe<Scalars['String']>
  fromPostalCode?: InputMaybe<Scalars['String']>
  parcelType: Scalars['String']
  shipmentDate?: InputMaybe<Scalars['String']>
  toCity?: InputMaybe<Scalars['String']>
  toCountry: Scalars['String']
  toPostalCode?: InputMaybe<Scalars['String']>
}

export type HouseNr = {
  addition: Scalars['String']
  letter: Scalars['String']
  number: Scalars['Int']
}

export type Location = {
  address: Address
  code?: Maybe<Scalars['String']>
  parcelShopName?: Maybe<Scalars['String']>
  type: Scalars['String']
}

export type Mutation = {
  addressbook: AddressBookMutation
  orders: OrdersMutation
}

export type Name = {
  additionalName?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

export type NameInput = {
  additionalName?: InputMaybe<Scalars['String']>
  companyName?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

export type Order = {
  accountId?: Maybe<Scalars['String']>
  id: Scalars['ID']
  pspId?: Maybe<Scalars['String']>
  shipper: Shipper
  timeCreated: Scalars['DateTime']
  timePaid?: Maybe<Scalars['DateTime']>
  total: CompositePrice
  userId?: Maybe<Scalars['String']>
}

export type OrderDetails = {
  order: Order
  shipments: Shipment[]
  trackAndTrace: TrackAndTraceInfo[]
}

export type OrderReference = {
  value: Scalars['String']
}

export type OrderReferenceInput = {
  value: Scalars['String']
}

export type OrdersContainer = {
  checkPromoCode?: Maybe<PromoCodeOut>
  findOrder?: Maybe<OrderDetails>
  findOrders: OrderDetails[]
  receivedShipments: ReceivedShipmentDto[]
  sentShipments: EnrichedShipment[]
}

export type OrdersContainerCheckPromoCodeArgs = {
  captcha: Scalars['String']
  carrier?: InputMaybe<Scalars['String']>
  fromCountryCode: Scalars['String']
  key: Scalars['String']
  toCountryCode: Scalars['String']
}

export type OrdersContainerFindOrderArgs = {
  orderId: Scalars['ID']
}

export type OrdersContainerFindOrdersArgs = {
  max?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  skip?: InputMaybe<Scalars['Int']>
}

export type OrdersContainerSentShipmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  date?: InputMaybe<Scalars['DateTime']>
  max?: InputMaybe<Scalars['Int']>
  query?: InputMaybe<Scalars['String']>
  skip?: InputMaybe<Scalars['Int']>
  trashed?: InputMaybe<Scalars['Boolean']>
}

export type OrdersMutation = {
  createOrder: OrderDetails
  shipments: ShipmentsMutation
}

export type OrdersMutationCreateOrderArgs = {
  accountId?: InputMaybe<Scalars['String']>
  shipments: ShipmentRequestInput[]
  shipperDto: ShipperInput
}

export type OriginCountriesInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromBusiness: Scalars['Boolean']
}

export type ParcelType = {
  category?: Maybe<ParcelTypeCategory>
  dimensions: Dimensions
  key: Scalars['String']
  maxWeightKg: Scalars['BigDecimal']
  minWeightKg: Scalars['BigDecimal']
  price?: Maybe<Price>
}

export type ParcelTypeCategory = {
  value: Scalars['String']
}

export type ParcelTypeCategoryInput = {
  value: Scalars['String']
}

export type ParcelTypeInput = {
  category?: InputMaybe<ParcelTypeCategoryInput>
  dimensions: DimensionsInput
  key: Scalars['String']
  maxWeightKg: Scalars['BigDecimal']
  minWeightKg: Scalars['BigDecimal']
  price?: InputMaybe<PriceInput>
}

export type ParcelTypesInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromBusiness: Scalars['Boolean']
  fromCountry: Scalars['String']
  fromPostalCode?: InputMaybe<Scalars['String']>
  toBusiness?: InputMaybe<Scalars['Boolean']>
  toCountry: Scalars['String']
  toPostalCode?: InputMaybe<Scalars['String']>
}

export type Payment = {
  fields: Scalars['MapType']
  pspUrl: Scalars['String']
}

export type PaymentsContainer = {
  getPaymentInfo?: Maybe<Payment>
}

export type PaymentsContainerGetPaymentInfoArgs = {
  attempt?: InputMaybe<Scalars['String']>
  baseUrl: Scalars['String']
  brand: Scalars['String']
  clientAppId: ClientAppId
  issuerId?: InputMaybe<Scalars['String']>
  orderId: Scalars['ID']
  paymentMethod: Scalars['String']
  xLang?: InputMaybe<Scalars['String']>
}

export type PickupRangeBound = {
  max: Scalars['String']
  min: Scalars['String']
}

export type PieceDimensions = {
  height?: Maybe<Scalars['Int']>
  length?: Maybe<Scalars['Int']>
  width?: Maybe<Scalars['Int']>
}

export type Postalcodes = {
  retrieveStreets: Street[]
}

export type PostalcodesRetrieveStreetsArgs = {
  countryCode: Scalars['String']
  postalCode: Scalars['String']
}

export type Price = {
  currency?: Maybe<Scalars['String']>
  vatRate?: Maybe<Scalars['BigDecimal']>
  withTax: Scalars['BigDecimal']
  withoutTax: Scalars['BigDecimal']
}

export type PriceInput = {
  currency?: InputMaybe<Scalars['String']>
  vatRate?: InputMaybe<Scalars['BigDecimal']>
  withTax: Scalars['BigDecimal']
  withoutTax: Scalars['BigDecimal']
}

export type PromoCode = {
  discountOnShippingCosts: Scalars['BigDecimal']
  key: Scalars['String']
}

export type PromoCodeBasicInput = {
  discountOnShippingCosts: Scalars['BigDecimal']
  key: Scalars['String']
}

export type PromoCodeOut = {
  carriers: Scalars['String'][]
  currentUses: Scalars['Long']
  discountOnShippingCosts: Scalars['BigDecimal']
  fromCountries: Scalars['String'][]
  key: Scalars['String']
  maxUses: Scalars['Long']
  toCountries: Scalars['String'][]
  userGenerated: Scalars['Boolean']
  validFrom: Scalars['DateTime']
  validUntil: Scalars['DateTime']
}

export type Query = {
  addressbook: AddressBookContainer
  capabilitiesContainer: CapabilitiesContainer
  orders: OrdersContainer
  paymentsContainer: PaymentsContainer
  postalcodes: Postalcodes
  user: UserContainer
}

export type ReceivedShipmentDto = {
  id: Scalars['String']
  receiverPostalCode?: Maybe<Scalars['String']>
  shipperName?: Maybe<Scalars['String']>
  trackAndTrace: TrackAndTraceInfo
}

export type Receiver = {
  address: Address
  email?: Maybe<Email>
  eori?: Maybe<Scalars['String']>
  name: Name
  phoneNumber?: Maybe<Scalars['String']>
  reference?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type ReceiverInput = {
  address: AddressInput
  email?: InputMaybe<EmailInput>
  eori?: InputMaybe<Scalars['String']>
  name: NameInput
  phoneNumber?: InputMaybe<Scalars['String']>
  reference?: InputMaybe<Scalars['String']>
  vatNumber?: InputMaybe<Scalars['String']>
}

export type Shipment = {
  application?: Maybe<Scalars['String']>
  contentDescription?: Maybe<Scalars['String']>
  ccEmails?: Maybe<Emails>
  createdBy?: Maybe<Scalars['String']>
  customsDeclaration?: Maybe<CustomsDeclaration>
  destination?: Maybe<Location>
  dimensions: PieceDimensions
  id: Scalars['String']
  networkProductKey: Scalars['String']
  onBehalfOf?: Maybe<Shipper>
  options: ShipmentOption[]
  orderId?: Maybe<Scalars['ID']>
  orderReference?: Maybe<OrderReference>
  origin?: Maybe<Location>
  parcelType: ParcelType
  printlessCode?: Maybe<Scalars['String']>
  promoCode?: Maybe<PromoCode>
  receiver: Receiver
  shipmentId: Scalars['String']
  shipmentTrackerCode?: Maybe<Scalars['String']>
  shipper: Shipper
  timeCreated: Scalars['DateTime']
  timeUpdated?: Maybe<Scalars['DateTime']>
  total: CompositePrice
  trackerCode?: Maybe<Scalars['String']>
  weight?: Maybe<Scalars['BigDecimal']>
}

export type ShipmentOption = {
  excludes?: Maybe<Scalars['String'][]>
  exclusions?: Maybe<ShipmentOption[]>
  implies?: Maybe<Scalars['String'][]>
  inputMax?: Maybe<Scalars['String']>
  inputMin?: Maybe<Scalars['String']>
  inputType?: Maybe<Scalars['String']>
  key: Scalars['String']
  optionType?: Maybe<Scalars['String']>
  price?: Maybe<Price>
  rank?: Maybe<Scalars['Int']>
}

export type ShipmentOptionRequestInput = {
  inputType?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  price?: InputMaybe<PriceInput>
  rank?: InputMaybe<Scalars['Int']>
}

export type ShipmentRequestInput = {
  application?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  ccEmails?: InputMaybe<EmailsInput>
  contentDescription?: InputMaybe<Scalars['String']>
  customsDeclaration?: InputMaybe<CustomsDeclarationInput>
  draftId?: InputMaybe<Scalars['String']>
  frontEndId?: InputMaybe<Scalars['String']>
  height?: InputMaybe<Scalars['Int']>
  id: Scalars['String']
  length?: InputMaybe<Scalars['Int']>
  options: ShipmentOptionRequestInput[]
  orderReference?: InputMaybe<OrderReferenceInput>
  parcelType: ParcelTypeInput
  promoCode?: InputMaybe<PromoCodeBasicInput>
  receiver: ReceiverInput
  shipper: ShipperInput
  timeUpdated?: InputMaybe<Scalars['DateTime']>
  trackerCode?: InputMaybe<Scalars['String']>
  weight?: InputMaybe<Scalars['BigDecimal']>
  width?: InputMaybe<Scalars['Int']>
}

export type ShipmentsMutation = {
  archive: Scalars['Int']
  trash: Scalars['Int']
  unarchive: Scalars['Int']
  untrash: Scalars['Int']
}

export type ShipmentsMutationArchiveArgs = {
  accountNumbers?: InputMaybe<Scalars['String'][]>
  selectionInversed?: InputMaybe<Scalars['Boolean']>
  shipmentIds: Scalars['String'][]
}

export type ShipmentsMutationTrashArgs = {
  accountNumbers?: InputMaybe<Scalars['String'][]>
  selectionInversed?: InputMaybe<Scalars['Boolean']>
  shipmentIds: Scalars['String'][]
}

export type ShipmentsMutationUnarchiveArgs = {
  accountNumbers?: InputMaybe<Scalars['String'][]>
  selectionInversed?: InputMaybe<Scalars['Boolean']>
  shipmentIds: Scalars['String'][]
}

export type ShipmentsMutationUntrashArgs = {
  accountNumbers?: InputMaybe<Scalars['String'][]>
  selectionInversed?: InputMaybe<Scalars['Boolean']>
  shipmentIds: Scalars['String'][]
}

export type Shipper = {
  address: Address
  email?: Maybe<Email>
  emailSubscription: Scalars['Boolean']
  eori?: Maybe<Scalars['String']>
  name: Name
  phoneNumber?: Maybe<Scalars['String']>
  vatNumber?: Maybe<Scalars['String']>
}

export type ShipperInput = {
  address: AddressInput
  email?: InputMaybe<EmailInput>
  emailSubscription: Scalars['Boolean']
  eori?: InputMaybe<Scalars['String']>
  name: NameInput
  phoneNumber?: InputMaybe<Scalars['String']>
  vatNumber?: InputMaybe<Scalars['String']>
}

export type ShippingFee = {
  currency?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['BigDecimal']>
}

export type ShippingFeeInput = {
  currency?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['BigDecimal']>
}

export type SortByInput = {
  direction: Direction
  field: Scalars['String']
}

export type Street = {
  city: Scalars['String']
  country?: Maybe<Scalars['String']>
  houseNumbers: HouseNr[]
  postalCode: Scalars['String']
  street?: Maybe<Scalars['String']>
}

export type TimeWindows = {
  deliveryDate?: Maybe<Scalars['String']>
  endTime?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  startTime?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
}

export type TimeWindowsInput = {
  fromCountry?: InputMaybe<Scalars['String']>
  fromPostalCode?: InputMaybe<Scalars['String']>
}

export type TrackAndTraceEvent = {
  category: Scalars['String']
  status: Scalars['String']
  timestamp: Scalars['DateTime']
  type: Scalars['String']
}

export type TrackAndTraceInfo = {
  barcode: Scalars['String']
  events: TrackAndTraceEvent[]
  expectedDeliveryMoment?: Maybe<Scalars['Instant']>
  lastCategory: Scalars['String']
  lastStatus: Scalars['String']
}

export type TransitDeliveryTime = {
  deliveryTime: Scalars['String']
  shipmentOption: Scalars['String']
}

export type TransitTimeDays = {
  standard: Scalars['Int']
  total: Scalars['Int']
  weekend: Scalars['Int']
}

export type TransitTimes = {
  cutoffMoment?: Maybe<Scalars['String']>
  days: TransitTimeDays
  expectedDeliveryDate?: Maybe<Scalars['String']>
  expectedDeliveryTimes: TransitDeliveryTime[]
  shipmentDate: Scalars['String']
}

export type TransitTimesInput = {
  businessUnit?: InputMaybe<Scalars['String']>
  carrier?: InputMaybe<Scalars['String']>
  fromCountry?: InputMaybe<Scalars['String']>
  fromPostalCode?: InputMaybe<Scalars['String']>
  parcelType: Scalars['String']
  shipmentDate?: InputMaybe<Scalars['String']>
  toCity?: InputMaybe<Scalars['String']>
  toCountry: Scalars['String']
  toPostalCode?: InputMaybe<Scalars['String']>
}

export type User = {
  accountNumbers?: Maybe<Scalars['String'][]>
  email: Email
  id: Scalars['String']
  isBusinessUser: Scalars['Boolean']
  name: Name
  organisationId?: Maybe<Scalars['String']>
  organisationType?: Maybe<Scalars['String']>
  parcelShopPsfKey?: Maybe<Scalars['String']>
  roles?: Maybe<Scalars['String'][]>
  timeLastLogin: Scalars['DateTime']
  timeRegistered: Scalars['DateTime']
  timeUpdated: Scalars['DateTime']
}

export type UserContainer = {
  findAllUsers: User[]
  userRoles: Scalars['String'][]
}

export type UserContainerFindAllUsersArgs = {
  organisationId: Scalars['String']
}

export type UserContainerUserRolesArgs = {
  email?: InputMaybe<Scalars['String']>
}

export type DestinationCountryFragment = { code: string; hasPostal: boolean }

export type ParcelTypeFragment = {
  key: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  minWeightKg: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  maxWeightKg: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dimensions: { maxHeightCm: any; maxLengthCm: any; maxWidthCm: any; maxSumCm?: any | null }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  price?: { withTax: any; withoutTax: any } | null
}

export type ShipmentOptionFragment = {
  key: string
  inputType?: string | null
  inputMin?: string | null
  inputMax?: string | null
  optionType?: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  price?: { withTax: any; withoutTax: any } | null
  exclusions?: { key: string }[] | null
}

export type CapabilityFragment = {
  productKey: string
  options: {
    key: string
    inputType?: string | null
    inputMin?: string | null
    inputMax?: string | null
    optionType?: string | null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    price?: { withTax: any; withoutTax: any } | null
    exclusions?: { key: string }[] | null
  }[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
}

export type AddressServiceQuery = {
  addressbook: {
    addresses: {
      id?: string | null
      tags: string[]
      email?: string | null
      phoneNumber?: string | null
      name: {
        firstName?: string | null
        lastName?: string | null
        companyName?: string | null
        additionalName?: string | null
      }
      address: {
        countryCode?: string | null
        zipCode?: string | null
        city?: string | null
        street?: string | null
        number?: string | null
        addition?: string | null
        additionalInfo?: string | null
        additionalAddressLine?: string | null
      }
    }[]
  }
}

export type DashboardServiceQuery = {
  orders: {
    sentShipments: {
      id: string
      orderId: string
      printlessCode?: string | null
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      timeCreated: any
      trackAndTrace?: {
        barcode: string
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        expectedDeliveryMoment?: any | null
        lastCategory: string
        events: {
          type: string
          category: string
          status: string
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          timestamp: any
        }[]
      } | null
      receiver: {
        name: { firstName?: string | null; lastName?: string | null; companyName?: string | null }
        address: {
          street: string
          number?: string | null
          city: string
          countryCode: string
          zipCode?: string | null
        }
        email?: { address: string } | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      total: { withTax: any; withoutTax: any }
    }[]
    receivedShipments: {
      id: string
      receiverPostalCode?: string | null
      shipperName?: string | null
      trackAndTrace: {
        barcode: string
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        expectedDeliveryMoment?: any | null
        lastCategory: string
        events: {
          type: string
          category: string
          status: string
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          timestamp: any
        }[]
      }
    }[]
  }
}

export type ServiceParcelQueryVariables = Exact<{
  customsDestinationInput: CustomsDestinationInput
  parcelParcelTypesInput: ParcelTypesInput
  parcelCapabilitiesInput: CapabilitiesInput
  parcelDestinationCountriesInput: DestinationCountriesInput
  parcelHandOffDatesInput: HandOffDatesInput
  parcelTimeWindowsInput: TimeWindowsInput
}>

export type ServiceParcelQuery = {
  capabilitiesContainer: { isCustomsDestinationQuery: boolean }
  parcel: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes: string[] | null
        implies: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
}

export type ServiceExpressQueryVariables = Exact<{
  customsDestinationInput: CustomsDestinationInput
  expressParcelTypesInput: ParcelTypesInput
  expressCapabilitiesInput: CapabilitiesInput
  expressDestinationCountriesInput: DestinationCountriesInput
  expressHandOffDatesInput: HandOffDatesInput
  expressTimeWindowsInput: TimeWindowsInput
}>

export type ServiceExpressQuery = {
  capabilitiesContainer: { isCustomsDestinationQuery: boolean }
  express: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes: string[] | null
        implies: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
}

// Follow the same structure as for parcel and express
export type ServiceExpressEconomyQuery = {
  capabilitiesContainer: { isCustomsDestinationQuery: boolean }
  expressEconomy: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes: string[] | null
        implies: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
}

export type ServiceQueryVariables = Exact<{
  customsDestinationInput: CustomsDestinationInput
  parcelParcelTypesInput: ParcelTypesInput
  parcelCapabilitiesInput: CapabilitiesInput
  parcelDestinationCountriesInput: DestinationCountriesInput
  parcelHandOffDatesInput: HandOffDatesInput
  parcelTimeWindowsInput: TimeWindowsInput
  expressParcelTypesInput: ParcelTypesInput
  expressCapabilitiesInput: CapabilitiesInput
  expressDestinationCountriesInput: DestinationCountriesInput
  expressHandOffDatesInput: HandOffDatesInput
  expressTimeWindowsInput: TimeWindowsInput
}>

export type ServiceQuery = {
  capabilitiesContainer: { isCustomsDestinationQuery: boolean }
  express: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes?: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
  parcel: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes?: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
  expressEconomy?: {
    parcelTypes: {
      key: string
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWeightKg: any
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maxWeightKg: any
      dimensions: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxHeightCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxLengthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxWidthCm: any
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        maxSumCm?: any | null
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      price?: { withTax: any; withoutTax: any } | null
    }[]
    capabilities: {
      productKey: string
      options: {
        key: string
        inputType?: string | null
        inputMin?: string | null
        inputMax?: string | null
        optionType?: string | null
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        price?: { withTax: any; withoutTax: any } | null
        exclusions?: { key: string }[] | null
        excludes?: string[] | null
      }[]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      parcelTypes: { price?: { withTax: any; withoutTax: any } | null }
    }[]
    destinationCountries: { code: string; hasPostal: boolean }[]
    handOffDates?: {
      handOffDates: {
        date: string
        expectedDeliveryDate?: string | null
        days: { standard: number }
        pickupRangeBound?: { min: string; max: string } | null
      }[]
    } | null
    timeWindows?:
      | {
          postalCode?: string | null
          deliveryDate?: string | null
          type?: string | null
          startTime?: string | null
          endTime?: string | null
          status?: string | null
        }[]
      | null
  }
}

export const DestinationCountryFragmentDoc = gql`
  fragment destinationCountryFragment on Country {
    code
    hasPostal
  }
`
export const ParcelTypeFragmentDoc = gql`
  fragment parcelTypeFragment on ParcelType {
    key
    minWeightKg
    maxWeightKg
    dimensions {
      maxHeightCm
      maxLengthCm
      maxWidthCm
      maxSumCm
    }
    price {
      withTax
      withoutTax
    }
  }
`
export const ShipmentOptionFragmentDoc = gql`
  fragment shipmentOptionFragment on ShipmentOption {
    key
    price {
      withTax
      withoutTax
    }
    exclusions {
      key
    }
    excludes
    implies
    inputType
    inputMin
    inputMax
    optionType
  }
`
export const CapabilityFragmentDoc = gql`
  fragment capabilityFragment on Capability {
    productKey
    options {
      ...shipmentOptionFragment
    }
    parcelTypes {
      price {
        withTax
        withoutTax
      }
    }
  }
  ${ShipmentOptionFragmentDoc}
`
export const CreateAddressMutationDocument = gql`
  mutation CreateAddressMutation($abe: AddressBookEntryInput!) {
    addressbook {
      createAddress(addressBookEntry: $abe) {
        id
      }
    }
  }
`

export const DeleteAddressMutationDocument = gql`
  mutation DeleteAddressMutation($id: ID!) {
    addressbook {
      deleteAddress(addressBookId: $id)
    }
  }
`

export const EditAddressMutationDocument = gql`
  mutation EditAddressMutation($id: ID!, $abe: AddressBookEntryInput!) {
    addressbook {
      updateAddress(addressBookId: $id, addressBookEntry: $abe) {
        id
      }
    }
  }
`

export const AddressServiceQueryDocument = gql`
  query addressServiceQuery($max: Int, $searchTerm: String, $countries: [String!], $tags: [String!]) {
    addressbook {
      addresses(max: $max, query: $searchTerm, countries: $countries, tags: $tags) {
        id
        tags
        email
        phoneNumber
        name {
          firstName
          lastName
          companyName
          additionalName
        }
        address {
          countryCode
          zipCode
          city
          street
          number
          addition
          additionalInfo
          additionalAddressLine
        }
      }
    }
  }
`

export const DashboardServiceQueryDocument = gql`
  query dashboardServiceQuery($searchTerm: String) {
    orders {
      sentShipments(max: 250, query: $searchTerm) {
        id
        orderId
        printlessCode
        trackAndTrace {
          barcode
          expectedDeliveryMoment
          lastCategory
          events {
            type
            category
            status
            timestamp
          }
        }
        receiver {
          name {
            firstName
            lastName
            companyName
          }
          address {
            street
            number
            city
            countryCode
            zipCode
          }
          email {
            address
          }
        }
        total {
          withTax
          withoutTax
        }
        timeCreated
      }
      receivedShipments {
        id
        trackAndTrace {
          barcode
          expectedDeliveryMoment
          lastCategory
          events {
            type
            category
            status
            timestamp
          }
        }
        receiverPostalCode
        shipperName
      }
    }
  }
`

export const ServiceParcelQueryDocument = gql`
  query serviceParcelQuery(
    $customsDestinationInput: CustomsDestinationInput!
    $parcelParcelTypesInput: ParcelTypesInput!
    $parcelCapabilitiesInput: CapabilitiesInput!
    $parcelDestinationCountriesInput: DestinationCountriesInput!
    $parcelHandOffDatesInput: HandOffDatesInput!
    $parcelTimeWindowsInput: TimeWindowsInput!
  ) {
    capabilitiesContainer {
      isCustomsDestinationQuery(customsDestinationInput: $customsDestinationInput)
    }
    parcel: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $parcelParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $parcelCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $parcelDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $parcelHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $parcelTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }
  }
  ${ParcelTypeFragmentDoc}
  ${CapabilityFragmentDoc}
  ${DestinationCountryFragmentDoc}
`

export const ServiceExpressQueryDocument = gql`
  query serviceExpressQuery(
    $customsDestinationInput: CustomsDestinationInput!
    $expressParcelTypesInput: ParcelTypesInput!
    $expressCapabilitiesInput: CapabilitiesInput!
    $expressDestinationCountriesInput: DestinationCountriesInput!
    $expressHandOffDatesInput: HandOffDatesInput!
    $expressTimeWindowsInput: TimeWindowsInput!
  ) {
    capabilitiesContainer {
      isCustomsDestinationQuery(customsDestinationInput: $customsDestinationInput)
    }
    express: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $expressParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $expressCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $expressDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $expressHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $expressTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }
  }
  ${ParcelTypeFragmentDoc}
  ${CapabilityFragmentDoc}
  ${DestinationCountryFragmentDoc}
`

export const ServiceExpressEconomyQueryDocument = gql`
  query serviceExpressQuery(
    $customsDestinationInput: CustomsDestinationInput!
    $expressEconomyParcelTypesInput: ParcelTypesInput!
    $expressEconomyCapabilitiesInput: CapabilitiesInput!
    $expressEconomyDestinationCountriesInput: DestinationCountriesInput!
    $expressEconomyHandOffDatesInput: HandOffDatesInput!
    $expressEconomyTimeWindowsInput: TimeWindowsInput!
  ) {
    capabilitiesContainer {
      isCustomsDestinationQuery(customsDestinationInput: $customsDestinationInput)
    }
    expressEconomy: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $expressEconomyParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $expressEconomyCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $expressEconomyDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $expressEconomyHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $expressEconomyTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }
  }
  ${ParcelTypeFragmentDoc}
  ${CapabilityFragmentDoc}
  ${DestinationCountryFragmentDoc}
`

export const ServiceQueryDocument = gql`
  query serviceQuery(
    $customsDestinationInput: CustomsDestinationInput!
    $parcelParcelTypesInput: ParcelTypesInput!
    $parcelCapabilitiesInput: CapabilitiesInput!
    $parcelDestinationCountriesInput: DestinationCountriesInput!
    $parcelHandOffDatesInput: HandOffDatesInput!
    $parcelTimeWindowsInput: TimeWindowsInput!
    $expressParcelTypesInput: ParcelTypesInput!
    $expressCapabilitiesInput: CapabilitiesInput!
    $expressDestinationCountriesInput: DestinationCountriesInput!
    $expressHandOffDatesInput: HandOffDatesInput!
    $expressTimeWindowsInput: TimeWindowsInput!
    ${
      isExpressEconomyEnabled
        ? `
    $expressEconomyParcelTypesInput: ParcelTypesInput!
    $expressEconomyCapabilitiesInput: CapabilitiesInput!
    $expressEconomyDestinationCountriesInput: DestinationCountriesInput!
    $expressEconomyHandOffDatesInput: HandOffDatesInput!
    $expressEconomyTimeWindowsInput: TimeWindowsInput!
    `
        : ''
    }
  ) {
    capabilitiesContainer {
      isCustomsDestinationQuery(customsDestinationInput: $customsDestinationInput)
    }
    express: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $expressParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $expressCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $expressDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $expressHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $expressTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }
    ${
      isExpressEconomyEnabled
        ? `expressEconomy: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $expressEconomyParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $expressEconomyCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $expressEconomyDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $expressEconomyHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $expressEconomyTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }`
        : ''
    }
    parcel: capabilitiesContainer {
      parcelTypes(parcelTypesInput: $parcelParcelTypesInput) {
        ...parcelTypeFragment
      }
      capabilities(capabilitiesInput: $parcelCapabilitiesInput) {
        ...capabilityFragment
      }
      destinationCountries(destinationCountriesInput: $parcelDestinationCountriesInput) {
        ...destinationCountryFragment
      }
      handOffDates(handOffDatesInput: $parcelHandOffDatesInput) {
        handOffDates {
          date
          days {
            standard
          }
          expectedDeliveryDate
          pickupRangeBound {
            min
            max
          }
        }
      }
      timeWindows(timeWindowsInput: $parcelTimeWindowsInput) {
        postalCode
        deliveryDate
        type
        startTime
        endTime
        status
      }
    }
  }
  ${ParcelTypeFragmentDoc}
  ${CapabilityFragmentDoc}
  ${DestinationCountryFragmentDoc}
`
